import React from 'react';
import { Button, Flex } from '@zillow/constellation';
import { useCustomViewsContext } from '../../context/CustomViewsContext';

export const DefaultFooter: React.FC = () => {
  const { setCustomViewsState } = useCustomViewsContext();
  return (
    <Flex display={'flex'} flexDirection={'row-reverse'} gap={'xs'} alignItems={'center'}>
      <Button
        buttonType={'secondary'}
        onClick={() => setCustomViewsState((prev) => ({ ...prev, isOpen: true, isEdit: true }))}
        type={'button'}
      >
        Edit views
      </Button>
    </Flex>
  );
};
